const apiUrl = process.env.VUE_APP_API_BASEURL;

export default {
  ticket: (communeId: number, customerUUID: string) =>
    `${apiUrl}/v2/publicTransportTicket/${communeId}/${customerUUID}`,
};
